import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {calendarDate, fullName} from 'shared/tools';
import InterviewSchedule from 'main/stores/interview_schedules/InterviewSchedule';

class InterviewInvite extends DomainObject {
  startDate;
  endDate;
  interviewSchedule;
  candidate;
  booked;

  _relations = {
    _dates: ['startDate', 'endDate'],
    interviewSchedule: InterviewSchedule
  };

  constructor(other) {
    super();

    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      interviewSchedule: observable,
      candidate: observable,
      booked: observable,
      scheduleName: computed,
      interviewerNames: computed,
      formattedStartDate: computed,
      formattedEndDate: computed
    });

    this.merge(other);
  }

  get scheduleName() {
    return this.interviewSchedule && this.interviewSchedule.templateName;
  }

  get interviewerNames() {
    const interviewers = (this.interviewSchedule && this.interviewSchedule.interviewers) || [];
    return interviewers.map(fullName).join(', ');
  }

  get formattedStartDate() {
    return calendarDate(this.startDate);
  }

  get formattedEndDate() {
    return calendarDate(this.endDate);
  }
}

export default InterviewInvite;
